import React from "react";
import { PeekBox, PeekTypography } from "@piiqtechnologies/ui-components";
export const WhiskerMinMaxLabel = ({ value, caption }) => (React.createElement(PeekBox, { sx: { textAlign: "center", minWidth: 50, position: "relative", zIndex: 6 } },
    React.createElement(PeekTypography, { variant: "body1", sx: { fontWeight: "fontWeightMedium", color: "grey.400", lineHeight: 1.4 } }, value),
    React.createElement(PeekTypography, { variant: "caption", sx: { color: "grey.400", fontSize: 12 } }, caption)));
export default WhiskerMinMaxLabel;
